import { render, staticRenderFns } from "./formulario.vue?vue&type=template&id=55919223&scoped=true"
import script from "./formulario.vue?vue&type=script&lang=js"
export * from "./formulario.vue?vue&type=script&lang=js"
import style0 from "./formulario.vue?vue&type=style&index=0&id=55919223&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55919223",
  null
  
)

export default component.exports